import { FullScreenModal } from '@pata-app/ui-modal';

import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import LoadingIndicator from '../../../../components/loadingIndicator/loadingIndicator';
import SectionWidth from '../../../../components/sectionWidth/sectionWidth';
import { useGetBusiness } from '../../../../queries/business.queries';
import { LoadingIndicatorWrapper } from '../../businessProfile.styled';
import NotFound from '../notFound/notFound';
import { TermsContainer } from './terms.styled';

// import { FullScreenModal } from './terms.styled';

export function Terms() {
  let { id } = useParams();

  const { data, isLoading } = useGetBusiness(id);

  const navigate = useNavigate();

  const handleToggleMenu = () => {
    navigate(`/p/${data.id}`);
  };

  return (
    <>
      {isLoading ? (
        <LoadingIndicatorWrapper>
          <LoadingIndicator message="Your business is being fetched, pronto!" />
        </LoadingIndicatorWrapper>
      ) : (
        <FullScreenModal
          hideCloseButton={data.listingStatus !== 'listed'}
          actions={[]}
          isOpen
          handleToggleModal={handleToggleMenu}
          modalTitle={`${data.name} Terms & Conditions`}
          modalDescription={''}
        >
          {data.termsAndConditions ? (
            <TermsContainer>
              <h2>{`${data.name} Terms & Conditions`}</h2>
              <p dangerouslySetInnerHTML={{ __html: atob(data?.termsAndConditions) }} />
            </TermsContainer>
          ) : (
            <NotFound />
          )}
        </FullScreenModal>
      )}
    </>
  );
}
